import { render } from "./DeactivatedUserView.vue?vue&type=template&id=c16bf89c"
import script from "./DeactivatedUserView.vue?vue&type=script&lang=js"
export * from "./DeactivatedUserView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__